// extracted by mini-css-extract-plugin
export default {"root":"styles_root__2dV2B","selected":"styles_selected__5bNMO"};